import platformsConfig from '../../../../config/platforms.json';

interface PlatformInfo {
  id: string;
  name: string;
  domain: string;
  logo: string;
  slug: string;
  type: string;
  fullySupported: boolean;
  featured: boolean;
}

export function getPlatformInfo(platformId: string): PlatformInfo | undefined {
  return platformsConfig.platforms.find(p => p.id === platformId);
}

export function getPlatformName(platformId: string): string {
  return getPlatformInfo(platformId)?.name || platformId;
}

export function getPlatformBySlug(slug: string): PlatformInfo | undefined {
  return platformsConfig.platforms.find(p => p.slug === slug);
}

export function getAllPlatforms() {
  return [...platformsConfig.platforms];
}

/**
 * Detect platform from a given URL.
 * - Checks against domain and aliases in platforms config.
 * - Returns PlatformInfo if matched, undefined otherwise.
 */
export function detectPlatformFromUrl(url: string): PlatformInfo | undefined {
  try {
    const parsed = new URL(url);
    const hostname = parsed.hostname.replace(/^www\./, '').toLowerCase();

    for (const platform of platformsConfig.platforms) {
      // Check main domain
      if (hostname === platform.domain.replace(/^www\./, '').toLowerCase()) {
        return platform;
      }
      // Check aliases
      if (Array.isArray(platform.aliases)) {
        for (const alias of platform.aliases) {
          if (hostname === alias.replace(/^www\./, '').toLowerCase()) {
            return platform;
          }
        }
      }
    }
  } catch {
    // Invalid URL
    return undefined;
  }
  return undefined;
}
